import React from 'react';
import QuestionManager from '../components/QuestionManager';

const AdminUserQuestions = () => {
  return (
    <QuestionManager 
      category="user" 
      title="Manage User Profile Questions"
      description="Configure questions that all users must complete"
    />
  );
};

export default AdminUserQuestions;
